export const config = {
    global: {
        sportid: []
    }
}